import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Typography,
} from "antd";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import CustomButton from "../../../components/custom/CustomButton";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { apiConfig, labelConfig, staticConfig } from "../teller.config";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { Text } = Typography;

const NewTeller = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(true);
  const [staffOptions, setStaffOptions] = useState([]);

  const { state } = useLocation();
  const tillId = state?.id;

  useEffect(() => {
    getTemplate();
  }, []);

  const breadcrumbItems = [
    {
      title: <Link to="/tlo0100">{labelConfig.manageLinkUserToTill}</Link>,
    },
    {
      title: (
        <Link to="/detail-tlo0100" state={{ id: tillId }}>
          {labelConfig.manageLinkUserToTillTeller}
        </Link>
      ),
    },
    { title: labelConfig.newTeller },
  ];

  function onCancel() {
    navigate("/detail-tlo0100", { replace: false });
  }

  const getTemplate = () => {
    let body = {
      session,
    };

    const url = `${apiConfig.Customizedteller}/${tillId}/tellers/template`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        let staffOptions = [];

        objList?.appUserDataOptions?.forEach((item) => {
          staffOptions.push({
            value: item.id,
            label: item.firstname + " " + item.lastname,
          });
        });

        setStaffOptions(staffOptions);

        setIsLoading(false);
      }
    });
  };

  const onSubmit = (formValues) => {
    const url = `${apiConfig.Customizedteller}`;

    formValues.startDate = BOM.DateTime(formValues.startDate, "only-date");
    formValues.endDate = BOM.DateTime(formValues.endDate, "only-date");
    formValues.status = formValues.status === true ? "A" : "I";
    formValues.tellerProfile = String(tillId);
    formValues.isAdmin = false;

    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
      // params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);

          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, "Teller linked to till successfully");
          navigate("/detail-tlo0100", { state: { id: tillId } });
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/tlo0100");
          setIsLoading(false);
        },
      },
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent
        pageTitle={labelConfig.newTeller}
        pageItems={breadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <div
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#9ca3af",
                letterSpacing: 1,
                textTransform: "uppercase",
                marginBottom: 14,
              }}
            >
              Teller Information
            </div>

            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  name="appUserId"
                  label={<Text strong>User's Name</Text>}
                  rules={[{ required: true, message: "Required Field" }]}
                >
                  <Select
                    placeholder="Select a user"
                    options={staffOptions}
                    showSearch
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    style={{ height: 44 }}
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="description"
                  label={<Text strong>Description</Text>}
                >
                  <Input
                    placeholder="Enter description"
                    style={{ height: 44 }}
                  />
                </Form.Item>
              </Col>

              {/* <Col span={8}>
                <Form.Item
                  name="tellerGlId"
                  label={<Text strong>Teller GL</Text>}
                  rules={[{ required: true, message: "Required Field" }]}
                >
                  <Select
                    placeholder="Select GL account"
                    options={DUMMY_GL_OPTIONS}
                    showSearch
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    style={{ height: 44 }}
                  />
                </Form.Item>
              </Col> */}

              <Col span={8}>
                <Form.Item
                  name="startDate"
                  label={<Text strong>From</Text>}
                  rules={[{ required: true, message: "Required Field" }]}
                >
                  <DatePicker
                    style={{ width: "100%", height: 44 }}
                    format="DD MMMM YYYY"
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="endDate"
                  label={<Text strong>To</Text>}
                  rules={[{ required: true, message: "Required Field" }]}
                >
                  <DatePicker
                    style={{ width: "100%", height: 44 }}
                    format="DD MMMM YYYY"
                  />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="status"
                  label={<Text strong>Status</Text>}
                  rules={[{ required: true, message: "Required Field" }]}
                >
                  <Select
                    placeholder="Select status"
                    options={[
                      { label: "Active", value: true },
                      { label: "Inactive", value: false },
                    ]}
                    style={{ height: 44 }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Divider />
            <Row>
              <CustomButton
                content="Submit"
                htmlType="submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
              />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps, null)(NewTeller);
